/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useState } from 'react';
import { useLanguage } from 'v4/lib/hooks/use-language';
import { CustomDropdown } from '../custom-dropdown';

export const LanguageDropdown = ({ isTranslationDropdown, ...props }) => {
  const [search, setSearch] = useState();
  const { data, refetch, createLoading, mutateAsync, isLoading } = useLanguage({
    search,
  });

  const languages = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  return (
    <CustomDropdown
      {...props}
      data={languages}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
      isTranslationDropdown={isTranslationDropdown}
    />
  );
};
